import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page28() {
  useEffect(() => {
    document.title = "Маяк — Страница 27"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page26" />
        <ForwardLink href="/page28" />
      </div>

      <p style={{ textAlign: "right" }}>27.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Как серебряный жетон в борделе.<br/>
        Пожелайте хорошего дня морякам.
      </p>
      <p>СТАРИК позволяет веревке немного соскользнуть. Это по-настоящему пугает МОЛОДОГО.</p>
      <p>Побелка капает на лицо и одежду МОЛОДОГО. Он кричит:</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Они не увидят этого<br/>
        в этот чертов шторм!
      </p>
      <p>СТАРИК смеется.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Они увидят! И будут рады это<br/>
        увидеть! Держи себя в руках, парень.<br/>
        Это отличная работа. Ты получишь высокие<br/>
        отметки в моем журнале. В их Евангелии!
      </p>
      <p><i>“Журнале?”</i> – думает МОЛОДОЙ. Он смотрит на старика... слишком долго.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Я опущу тебя на несколько футов.
      </p>
      <p>
        СТАРИК опускает его еще немного; МОЛОДОЙ скользит очень быстро. Внезапно...<br/>
        Шкив вращается слишком быстро... МОЛОДОЙ и движущийся крепеж<br/>
        быстро спускаются и ОСТАНАВЛИВАЮТСЯ.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Полегче.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты в надежных руках.
      </p>
      <p>Еще один спуск: ЖЕСТКИЙ.</p>
      <p>СТАРИК не может справиться? Он привязывает здоровую ногу к подиуму (смотровой площадке).</p>
      <p>СПУСК! Дальше, чем в прошлый раз. ПОБЕЛКА БРЫЗГАЕТ.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Полегче!
      </p>
      <p>МОЛОДОЙ раскачивается на ветру...</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Хватит трястись, парень.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Это не я!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты!
      </p>
      <p style={{ textAlign: "right" }}>27.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page26" />
        <ForwardLink href="/page28" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710019523/the-lighthouse-script/tkptxlnufmxkga91bknq.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page28;
